import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../../utils/ItemsPerPageValue";
import { parseAxiosError } from "../../../../../utils/response";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../../../elements/filter/ItemsPerPageSelect";
import GoToBackButton from "../../../../elements/goToBack/GoToBack";
import Notification from "../../../../elements/notification/Notification";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import MaterialPagination from "../../../../styles/materialPagination";
import ExchangeHistoryFilter from "./ExchangeProfitDetailsFilter";
import FilterAppliedList from "../../../../elements/filter/FilterAppliedList";
import ExchangeProfitDetailsList from "./ExchangeProfitDetailsList";

import { StyledExchangeProfitDetails } from "../styledExchangeProfit";
import { StyledContentWrapper } from "../../../../styles/styledMain";

const ExchangeProfitDetailsContainer = ({ match }) => {

  const [exchanges, setExchanges] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "exchange-history", false, true),
    "pair.user.email": checkFilterItem(history, "pair.user.email", null),
    "pair.user.nickname": checkFilterItem(history, "pair.user.nickname", null),
    "pair.exchangePair.inService.name": checkFilterItem(history, "pair.exchangePair.inService.name", null),
    "pair.exchangePair.outService.name": checkFilterItem(history, "pair.exchangePair.outService.name", null),
    "pair.exchangePair.inCurrency.asset": checkFilterItem(history, "pair.exchangePair.inCurrency.asset", null),
    "pair.exchangePair.outCurrency.asset": checkFilterItem(history, "pair.exchangePair.outCurrency.asset", null),
    "inAmount[gte]": checkFilterItem(history, "inAmount[gte]", null, true),
    "inAmount[lte]": checkFilterItem(history, "inAmount[lte]", null, true),
    "outAmount[gte]": checkFilterItem(history, "outAmount[gte]", null, true),
    "outAmount[lte]": checkFilterItem(history, "outAmount[lte]", null, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchExchanges = () => {
    let filterUrl = fetchFilterData(filterData);

    history.replace(filterUrl);
    axios.get("/api/exchanges" + filterUrl + "&exchangeProfitStabling.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setExchanges(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchExchanges();
  }, [filterData]);

  if (!exchanges) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <StyledContentWrapper>
      <StyledExchangeProfitDetails>
        <Notification
          notification={notification}
          setNotification={setNotification}
        />
        <div className="content-head">
          <GoToBackButton handler={() => {history.goBack();}} />
          <ExchangeHistoryFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ExchangeProfitDetailsList
          exchanges={exchanges}
          filterData={filterData}
          notification={notification}
          setNotification={setNotification}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledExchangeProfitDetails>
    </StyledContentWrapper>
  );
};

export default ExchangeProfitDetailsContainer;